import React, { useState, useEffect } from "react";

// Qty a line gives back to the item's remaining stock when it is opened or
// removed. Stock only counts saved lines with quantity_type 'OLD', so a saved
// line with an empty type (Sale Order) never took any stock and gives none back;
// a line changed in this session already had its qty taken off in the form.
export const qtyGivenBack = (line, qty) => {
    const value = parseFloat(qty) || 0;
    return line.isNewQty === '' && !line.remainingFromSession ? 0 : value;
};

const ViewNormalQuntity = ({ callBack, data, isConvert, isReturned }) => {

    const [normalRemaingQuantity, setNormalRemaingQuantity] = useState(0);
    const [normalQuantity, setNormalQuantity] = useState(0);
    const [normalItem, setNormalItem] = useState({});

    useEffect(() => {
        console.log('data', JSON.stringify(data));
        //let qty = data.normal_remaining_quantity > 0 ? (data.normal_remaining_quantity + data.quantity) : 0;
        let qty = data.normal_remaining_quantity  + qtyGivenBack(data, data.quantity);
        if(qty < 0){
            qty = data.quantity;
        }
        let item = {
            ...data,
            normal_remaining_quantity: qty,
            availableQty: qty
        }
        setNormalItem(item);
        setNormalQuantity(data.quantity);
        //setNormalRemaingQuantity(data.isNewQty == 'NEW' ? 0 : qty);
        setNormalRemaingQuantity(data.normal_remaining_quantity > 0 ? data.normal_remaining_quantity : 0);
    }, []);

    const handleChangeNormalQty = (e) => {
        let value = e.target.value;
        value = value * 1;
        if (/^[0-9]*$/.test(value)) {
            setNormalQuantity(value);
        }
    }

    const saveNormalQty = () => {
        let remaingQty = normalItem.availableQty;
        if (normalItem.isNewQty == 'NEW') {
            if (parseInt(normalQuantity) <= 0) {
                alert('Quantity can not be less than or equal to 0.');
                return;
            } else if (parseInt(normalQuantity) > 0) {

            } else {
                alert('Please enter valid quantity.');
                return;
            }
        } else {
            console.log('remaingQty', remaingQty);
            if (parseInt(normalQuantity) > remaingQty) {
                alert('Quantity can not be greater than remaining quantity.');
                return;
            } else if (parseInt(normalQuantity) <= 0) {
                alert('Quantity can not be less than or equal to 0.');
                return;
            } else if (parseInt(normalQuantity) > 0 && parseInt(normalQuantity) <= remaingQty) {

            } else {
                alert('Please enter valid quantity.');
                return;
            }
        }

        let updatedData = {};
        updatedData = {
            ...normalItem,
            quantity: parseInt(normalQuantity),
            trackingType: 'Normal',
            isNewQty: normalItem.isNewQty ? normalItem.isNewQty : 'OLD'
        }


        console.log('updatedData', JSON.stringify(updatedData));
        callBack(updatedData, false);

    }

    return (
        <div>

            <div className="form-group row">
                {
                    data.itemCreateType != 'SERVICE' &&
                    <span>
                        Available Quantity Is : {normalRemaingQuantity} 
                    </span>
                }
            </div>

            <div className="form-group row">
                <div className="col-6">
                    <div className="form-material open">
                        <input
                            type="text"
                            className="form-control"
                            id="serial_no"
                            name="without_sr_quantity"
                            value={normalQuantity}
                            onChange={(e) => handleChangeNormalQty(e)}
                            placeholder="Enter Quantity"
                            maxLength="3"
                            disabled={isConvert || isReturned}
                        />
                        <label htmlFor="login-username">Enter Quantity </label>
                    </div>
                </div>
            </div>
            {
                !isConvert && !isReturned &&
                <div className="form-group row">
                    <div className="col-12">
                        <button
                            type="submit"
                            className="btn btn-alt-primary"
                            onClick={() => saveNormalQty()}
                        >
                            <i className="fa fa-check mr-5"></i> Save
                        </button>
                    </div>
                </div>
            }


        </div>
    )
}
export default ViewNormalQuntity